import { makeSx } from '../../../../theme/_utils'

export default makeSx({
    PatientInsiResultDialogContent: {
        display: 'flex',
        gap: '1rem',
        flexDirection: 'column',
        paddingBottom: '4rem',
    },
})
